import { render, staticRenderFns } from "./ViewerWrapper.vue?vue&type=template&id=6798dfeb&scoped=true"
import script from "./ViewerWrapper.vue?vue&type=script&lang=js"
export * from "./ViewerWrapper.vue?vue&type=script&lang=js"
import style0 from "./ViewerWrapper.vue?vue&type=style&index=0&id=6798dfeb&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6798dfeb",
  null
  
)

export default component.exports